import React, { useEffect, useState } from 'react'
import Box from '@mui/material/Box'
import { useNavigate } from 'react-router-dom'
import type { ManufactureListType, PlatformListType } from '../types'
import { ROUTES } from '../../../consts/Routes'
import CustomAutoComplete from '../../../components/CustomAutoComplete'
import CustomButton from '../../../components/CustomButton'
import BotTypeDropDown from '../BotTypeDropDown'
import { useAppDispatch } from '../../../reducers/hooks'
import { userReducer } from '../../../reducers/user/userReducer'

interface ManufactureTabProps {
  manufacturerList: ManufactureListType[]
  platformList: PlatformListType[]
}

const ManufacturerTab: React.FC<ManufactureTabProps> = ({ manufacturerList, platformList }): JSX.Element => {
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const [selectedManufacturer, setSelectedManufacturer] = useState<ManufactureListType | null>(null)
  const [selectedBotType, setSelectedBotType] = useState<string | null>(null)
  const [isButtonDisabled, setIsButtonDisabled] = useState(true)

  const handleAutocompleteChange = (event: any, newValue: ManufactureListType | null): void => {
    setSelectedManufacturer(newValue)
  }

  const handleButtonDisabled = (): void => {
    setIsButtonDisabled(!(selectedManufacturer !== null && selectedBotType !== null))
  }

  const handleButtonClick = (): void => {
    if (selectedManufacturer !== null) {
      dispatch(userReducer.actions.changePlatformId(selectedManufacturer.manufacturer_platform_id))
      localStorage.setItem('platformId', selectedManufacturer.manufacturer_platform_id)
      dispatch(userReducer.actions.changePlatformNickname(selectedManufacturer.manufacturer))
      localStorage.setItem('platformNickname', selectedManufacturer.manufacturer)
      navigate(ROUTES.CHAT)
    }
  }

  useEffect(() => {
    handleButtonDisabled()
  }, [selectedManufacturer, selectedBotType])

  return (
    <>
      <Box mb={2} mt={2}>
        <CustomAutoComplete
          options={manufacturerList}
          getOptionLabel={(manufacturerList) => `${manufacturerList.manufacturer} ${manufacturerList.manufacturer_platform_id}`}
          value={selectedManufacturer}
          onChange={handleAutocompleteChange}
          placeholder="Select Manufacturer"
        />
      </Box>
      <BotTypeDropDown platformList={platformList} setSelectedBotType={setSelectedBotType}/>
      <CustomButton
        onClick={handleButtonClick}
        disabled={isButtonDisabled}
        label="Select Manufacturer"
      />
    </>
  )
}

export default ManufacturerTab
